/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './line-item-list-summary.component.html';

@Component({
  standalone: false,
  selector: 'adn-line-item-list-summary',
  template
})
export class LineItemListSummaryComponent {
  @Input() items: any[] = [];
}
